export default {
  fillInOrder: "Compila l'ordine dell'agente di acquisto",
  inputTips: "(le colonne contrassegnate con <span style='color: red'>*</span> sono obbligatorie)",
  process: {
    first: "Compila l'ordine e invia",
    second: 'Paga il prodotto e le spese di spedizione nazionali',
    three: "Attendi l'arrivo del tuo prodotto in magazzino",
  },
  productInfo: 'Informazioni sul prodotto',
  productInfoTips:
    'Tutti i prodotti disponibili per il servizio di agente di acquisto visualizzati su acbuy sono prodotti recuperati da piattaforme di acquisto di terze parti e non sono venduti direttamente da acbuy. Pertanto, in caso di problemi di contraffazione relativi ai prodotti sopra menzionati, tutte le responsabilità derivanti saranno a carico dei venditori corrispondenti sulla piattaforma di terze parti, mentre acbuy non si assumerà alcuna responsabilità correlata, sussidiaria o congiunta.',
  fees: 'Spese',
  feeStandard: 'Tariffe',
  feeStandardTips:
    "Per l'ordine dell'agente di acquisto che invii su questa pagina, se il prodotto proviene da piattaforme di terze parti come Kongfuzi Used Books, Xiaohongshu e Youzan, ecc., è possibile che il prodotto non possa essere acquistato. Il prodotto è associato a rischi di spedizione o potrebbero essere addebitate spese di servizio aggiuntive. Le spese di servizio effettive devono essere verificate dall'agente. Per maggiori dettagli, consulta 'Centro assistenza - Tariffe del servizio di agente di acquisto di terze parti'.",
  link: 'Link',
  name: 'Nome',
  remark: 'Nota',
  unitPrice: 'Prezzo unitario (CNY)',
  qty: 'Qtà',
  goodsAttr: 'Specifiche o materiale',
  chinaPostage: 'Spese di spedizione (CNY)',
  holder: {
    inputUrl: "Si prega di incollare l'URL del prodotto",
    inputName: 'Si prega di inserire qui il nome del prodotto (massimo 100 caratteri)',
    inputAttr: 'Si prega di inserire la specifica dei prodotti',
    inputRemark:
      "Se l'articolo ha più modelli, dimensioni, colori, ecc., si prega di specificare ciò di cui si ha bisogno qui in base alla descrizione della classificazione sulla pagina del prodotto. Se si acquista lo stesso prodotto ma con specifiche diverse, si prega di separare l'ordine.",
    contactName: 'Si prega di inserire il proprio nome di contatto',
    contactEmail: 'Si prega di inserire il proprio indirizzo e-mail di contatto',
    contactPhone: 'Si prega di inserire il proprio numero di telefono di contatto',
  },
  other: 'Altro (opzionale)',
  productImg: 'Immagini del prodotto',
  fareTip:
    "Spese di spedizione nazionali al nostro magazzino (in caso di dubbi, inserisci 0, l'agente verificherà e avvierà un pagamento)",
  customizedLogisticsForm: 'Modulo di richiesta logistica personalizzata',
  submitInfo: 'Invia informazioni sul prodotto',
  customizedProcess: {
    first: "Compila l'ordine e invia",
    second: 'Invia informazioni sul prodotto',
    three: 'Attendi che acbuy ti contatti',
  },
  deliveryAddress: 'Indirizzo di spedizione',
  contactDetail: 'Dettagli di contatto',
  contactName: 'Nome contatto',
  contactPhone: 'Telefono contatto',
  contactEmail: 'E-mail contatto',
  customizedLogisticsInformation: 'Informazioni logistiche personalizzate',
  fromWarehouse: 'Dal magazzino',
  manuallyFill: 'Compila manualmente le informazioni sul prodotto',
  contactInfoTips1:
    "· Al fine di servirti meglio, compila il modulo in modo veritiero e dettagliato. Entro tre giorni lavorativi dall'invio della richiesta, il personale dedicato ti contatterà.",
  contactInfoTips2:
    '· Per i pacchi inferiori a 30 kg, si consiglia ai clienti di scegliere la consegna logistica online.',
  contactInfoTips3:
    "· I servizi personalizzati riguardano solo il trasporto logistico e le merci vengono ispezionate solo per l'aspetto, e non viene fornita un'ispezione di qualità dettagliata delle merci.",
  myWarehouse: 'Il mio magazzino',
  itemName: 'Nome articolo',
  volume1: "Dimensioni del pacco dopo l'imballaggio",
  volume: 'Volume (cm)',
  weight: 'Peso',
  length: 'Lunghezza',
  width: 'Larghezza',
  height: 'Altezza',
  warehouseItem: 'Articolo in magazzino',
  manuallyItem: 'Articolo manuale',
  submitSuccess: 'Richiesta di logistica personalizzata inviata con successo',
  submitMsg: 'Ti contatteremo al più presto, ti preghiamo di attendere pazientemente.',
  inputProductMsg: 'Si prega di inserire il messaggio del prodotto',
  selectZone: 'Si prega di selezionare il prefisso per il numero di telefono di contatto',
  productName: 'Link o nome del prodotto',
}
